import React from 'react';
import { 
  PageWrapper,
  Text, 
  Container, 
} from '@Main/elements';
import { P } from '@helpers';

export const WritingAbout = ({t}) => {
  return (
    <PageWrapper darkMode={false}>
        <Container paddingTop='99px' marginLeft='102px' paddingBottom='50px' marginRight='111px'>
          <Text width='679px' paddingBefforeText="45px">
            <h1>{t("Writing about Soft-FX products and solutions")}</h1>
            <p>
              {t("The content that is created within Soft-FX or by third parties at our request, in the vast majority of cases, is intended to promote Soft-FX products and solutions. No one but us knows better how our creations perform and what their advantages are, so there are specific requirements for content about products and solutions regarding tone and voice.")}
            </p>
          </Text>
        </Container>
        <Container marginLeft='102px' paddingBottom='50px' marginRight='188px'>
          <P weight='600' size='15px' height='30px'>{t("Soft-FX content does not utilize empty hyperboles")}</P>
          <P weight='400' size='15px' height='30px' marginTop='10px'>
            {t("Such an approach deprives content of uniqueness and is inappropriate for our purposes because hyperbole that is not supported by facts does not tell the reader anything useful. Here's an example of a sentence that won't fit the product description:")}
          </P>
          <P weight='400' size='15px' height='30px' color='#005090' marginTop='30px'>
            {t("Ex.: TickTrader Liquidity Aggregator is the best offer on the market.")}
          </P>
        </Container>
        <Container marginLeft='102px' paddingBottom='50px' marginRight='111px'>
          <P weight='600' size='15px' height='30px'>{t("We provide no objective information to support such an assertion")}</P>
          <P weight='400' size='15px' height='30px' marginTop='10px'>
            {t("Now consider this sentence:")}
          </P>
          <P weight='400' size='15px' height='30px' color='#005090' marginTop='30px' marginBottom='30px'>
            {t("Ex.: TickTrader Liquidity Aggregator is a highly relevant product for crypto exchanges that have close to zero customer numbers at the time of launch and a strong need for a reliable crypto liquidity aggregation tool.")}
          </P>
          <P weight='400' size='15px' height='30px'>
            {t("We used a more low-key alternative, but the reader now has some information to ponder.")}
          </P>
        </Container>
        <Container marginLeft='102px' paddingBottom='50px' marginRight='111px'>
          <P weight='600' size='15px' height='30px'>{t("Soft-FX content utilizes relevant numbers whenever possible")}</P>
          <P weight='400' size='15px' height='30px' marginTop='10px'>
            {t("If we can provide the hard numbers that describe the function of a product or solution from the perspective we need, that information should be used in the content. A few numbers can be much more useful to a potential customer than a few paragraphs of text.")}
          </P>
        </Container>
     </PageWrapper>
  );
};